module.exports = __webpack_public_path__ + "static/img/gzz3.638db6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/gzz3.png
// module id = 58Bl
// module chunks = 2